/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type DeleteTenantInput = {
    clientMutationId: string;
    tenantId: string;
};
export type useDeleteTenantMutationVariables = {
    input: DeleteTenantInput;
};
export type useDeleteTenantMutationResponse = {
    readonly deleteTenant: {
        readonly errors: ReadonlyArray<{
            readonly code: string | null;
            readonly path: ReadonlyArray<string | null> | null;
            readonly message: string | null;
            readonly type: string | null;
        } | null> | null;
    } | null;
};
export type useDeleteTenantMutation = {
    readonly response: useDeleteTenantMutationResponse;
    readonly variables: useDeleteTenantMutationVariables;
};



/*
mutation useDeleteTenantMutation(
  $input: DeleteTenantInput!
) {
  deleteTenant(input: $input) {
    errors {
      code
      path
      message
      type
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "DeleteTenantPayload",
            "kind": "LinkedField",
            "name": "deleteTenant",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "InputError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "code",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "path",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "message",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "useDeleteTenantMutation",
            "selections": (v1 /*: any*/),
            "type": "RootMutationType",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "useDeleteTenantMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "53c33c7086a8dbbd71450e52697eb312",
            "id": null,
            "metadata": {},
            "name": "useDeleteTenantMutation",
            "operationKind": "mutation",
            "text": "mutation useDeleteTenantMutation(\n  $input: DeleteTenantInput!\n) {\n  deleteTenant(input: $input) {\n    errors {\n      code\n      path\n      message\n      type\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '9122dc83b2d4e2ca6bd0499926383bc6';
export default node;
